import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as dateutil from '@/util/date-helper';

@Component({
    name: 'DatePicker'
})
export default class DatePicker extends Vue {

    currentDate!: calendar.DateItem;

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    @Prop({ type: Number, default: 20 }) YearMinMax!: Number;
    @Prop({ type: String, default: dateutil.uGetDateFormat('yyyy-MM-DD', new Date()) }) value !: string;
    @Prop({ type: String }) placeholder !: string;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ type: Boolean }) showModal!: boolean;
    @Prop({ type: Boolean }) showEndModal!: boolean;

    MonthMatrix: Array<Array<calendar.DateItem>> = [];
    YearArray: Array<number> = [];
    MonthArray: Array<number> = [];

    SelectItems: Array<Date> = [];

    baseValue: string | null = dateutil.uGetDateFormat('yyyy-MM-DD', dateutil.IEDate(this.value));

    isShowPicker: boolean = false;
    isInMouse: boolean = false;

    posX: number = 0;
    posY: number = 0;

    changedShowModal!:boolean;
    changedShowEndModal!:boolean;

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M T H O D S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    // 월 날짜 출력
    setMonthMatrix() {
        let datePickerMatrix = [];
        let Rows = [];
        let today = new Date();
        let daysList = dateutil.uGetDaysInMonth(this.dateValue);

        for (let i = 0; i < daysList.length; i++) {
            let date = daysList[i];

            let isToday =
                date.getFullYear() == today.getFullYear() &&
                date.getMonth() == today.getMonth() &&
                date.getDate() == today.getDate();


            let sDate = dateutil.uGetDateFormat('yyyy-MM-DD', date);
            let cDate = dateutil.uGetDateFormat('yyyy-MM-DD', dateutil.IEDate(this.baseValue));

            let dateItem = {
                date: date,
                selected: sDate == cDate,
                isToday: isToday,
                isSun: date.getDay() == 0,
                isSat: date.getDay() == 6
            }

            Rows.push(dateItem);

            if ((i + 1) % 7 == 0) {
                let NewRows = new Array;
                NewRows = Object.assign(NewRows, Rows);
                datePickerMatrix.push(NewRows);
                Rows = [];
            }
        }

        this.MonthMatrix = datePickerMatrix;
    }

    // 날짜 선택
    selectDate(date: Date) {
        this.baseValue = dateutil.uGetDateFormat('yyyy-MM-DD', date);
        if(!isNaN(Number(this.baseValue)))
        {
            this.value = dateutil.DateAndTimeSplitor(this.baseValue)[0];
        }
        this.$emit('input', this.baseValue);
        this.$emit('close');
    }

    // 이전 달 선택
    monthPrev() {
        this.baseValue = dateutil.uGetMonthStartPrev(dateutil.IEDate(this.dateValue)).toString();
        this.setMonthMatrix();
    }

    // 다음 달 선택
    monthNext() {
        this.baseValue = dateutil.uGetDate(1, dateutil.uGetMonthStartDate(this.dateValue), 'month').toString();
        this.setMonthMatrix();
    }

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    get DateFormat() {
        return dateutil.uGetDateFormat(this.$t('M_Schedule_Dateformat2').toString(), this.dateValue)
    }

    get WeekList() {
        let weekarray = [
            this.$t('일').toString(),
            this.$t('월').toString(),
            this.$t('화').toString(),
            this.$t('수').toString(),
            this.$t('목').toString(),
            this.$t('금').toString(),
            this.$t('토').toString(),
        ];
        return weekarray;
    }

    get dateValue(): Date {
        return dateutil.IEDate(this.baseValue);
    }

    @Watch('MonthMatrix')
    monthMatrixChanged(newVal: Array<Array<calendar.DateItem>>) {
        console.log('monthMatrix', newVal);
    }

    @Watch("value")
    onValueChanged(value: string | null) {
        let newvalue = dateutil.IEDate(value);
        if(!isNaN(Number(newvalue)))
        {
            this.baseValue = value;
        }
    }

    @Watch("baseValue")
    onBaseValueChanged(value: string) {
        this.setMonthMatrix();
        // if(!isNaN(Number(value)))
        // {
        //     this.value = dateutil.DateAndTimeSplitor(value)[0];
        // }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.setMonthMatrix();
    }
}
